<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Underwriter Status</h5>

    <GroupedOptions
      @input="(value) => $emit('input', value)"
      :value="value"
      :options="options"
      native-type="radio"
      button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
    />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import GroupedOptions from '@components/GroupedOptions'

export default defineComponent({
  name: 'SaveReportWizardUnderwriterFilters',
  components: {
    GroupedOptions
  },
  emits: ['input'],
  props: {
    value: String
  },
  setup() {
    const options = ['Lead', 'Follow', 'All'].map((value) => ({
      value,
      label: value
    }))

    return {
      options
    }
  }
})
</script>
